import axios from 'axios';
import fn from "@/shared/utils/commonFunctions.js";
import LazUtils from '@/shared/utils/LazUtils';

const syncInterceptors = {
  setSyncInterceptors: (axiosInstance) => {
    const requestList = {};
    const canceledMessage = 'canceled';

    axiosInstance.interceptors.request.use(
      (config) => {
        let requestId = config.url;
        if (!fn.isEmpty(config.params) && !config.params["avoidsynccancellation"]) {
          requestId += config.params["syncuniquekey"] ?? '';
        } else {
          requestId = LazUtils.newGuid();
        }

        if (requestList[requestId]?.timeout) {
          clearTimeout(requestList[requestId].timeout);
          requestList[requestId].loader?.hide();
        }

        if (config.method === 'get' && requestList[requestId]?.cancelFn) {
          requestList[requestId].cancelFn(canceledMessage);
        }

        config.cancelToken = new axios.CancelToken((cancelFn) => {
          requestList[requestId] = { cancelFn, loader: config.LOADER };
        });

        return new Promise((resolve) => {
          requestList[requestId].timeout = setTimeout(() => {
            requestList[requestId].timeout = null;
            resolve(config);
          }, 30);
        });
      },
      (error) => Promise.reject(error)
    );

    axiosInstance.interceptors.response.use(
      (response) => {
        const requestId = response.config.url + (response.config.params?.["syncuniquekey"] ?? '');
        delete requestList[requestId];
        return response;
      },
      (error) => Promise.reject({ ...error, canceled: error.message === canceledMessage })
    );
  },
};

export default syncInterceptors;